import {gatewayInstance} from "../../axiosInstance";
import {SERVICE_ENDPOINT} from "../../const";

export const searchApprovals = async (data) => {
  try {
    console.log("searchApprovals", data);
    const response = await gatewayInstance.post(
      "/financeservice/ApprovalManager/search",
      data,
    );
    console.log("searchApprovals res", response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getApprovedUserData = async (dedId, detId) => {
  try {
    console.log("searchApprovals-----", dedId);
    const response = await gatewayInstance.post(
      `/financeservice/ApprovalManager/approver/${dedId}/${detId}`,
    );
    console.log("searchApprovals res", response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const processApproval = async (data) => {
  try {
    const  res =  await gatewayInstance.post(
        "/financeservice/ApprovalManager/approveAction",
        data,
    );
    return res.data;
  } catch (e) {
    console.error(e);
  }
};

export const approvesById = async (id) => {
  try {
    console.log("response approvesById", id);
    const response = await gatewayInstance.get(
      `/financeservice/ApprovalManager/${id}`,
    );
    console.log("approvesById", response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const dedTxnDelete = async (detId, username) => {
  try {
    const response = await gatewayInstance.delete(
        `${SERVICE_ENDPOINT.FINANCE}/ApprovalManager/delete-txn/${detId}`,
        {
          params: { modifiedBy: username },
        }
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

